module.exports = __webpack_public_path__ + "media/images/bg/shapes/cloud-blue-60b2c77b6b122658b8ffe3bc26977357.svg";